<template>
  <div>
    <ul class="metro_tmtimeline">
      <li v-for="(reg, idx) in estados" :class="reg.color" :key="idx">
        <div class="metro_tmicon">
          <i class="bi bi-check-lg"></i>
        </div>
        <div class="metro_tmlabel">
          <h3>{{ reg.tipo_Documento }}</h3>
          <div>
            <span>{{ reg.prefijo }} {{ reg.numero }}</span>
          </div>
          <span>{{ moment(reg.fecha_Emision).format("DD/MM/YYYY") }}</span>
        </div>
      </li>
    </ul>
    <CElementCover v-show="loading">
      <CSpinner grow color="info" size="sm" />
    </CElementCover>
  </div>
</template>

<script>
  import moment from "moment";
  import { dataSeguimientoCotizacion } from "@/apiData";

  export default ({
    name: "QuoteTrackingPanel",
    data() {
      return {
        loading: false,
        estados: []
      }
    },
    props: {
      IdQuote: String
    },
    methods: {
      moment,
      async getDataOrderTracking() {
        const { response } = await dataSeguimientoCotizacion(this, this.IdQuote);

        this.estados = response;
      }
    },
    async mounted() {
      this.loading = true

      await this.getDataOrderTracking();

      this.loading = false
    },
    setup() {

    },
  });
</script>
